
import { TimeIntervalEnum as timeIntervalEnum } from "./enums/timeIntervalEnum";
import * as moment from "moment";

export function getBeginPeriodSelection(selectedInterval: number | undefined | null, dateTimePicker: string | undefined | null): Date {

    if (selectedInterval == null || selectedInterval == undefined) {
        selectedInterval = timeIntervalEnum.Day;                            // LastDay
    }

    if (dateTimePicker == null || dateTimePicker == undefined) {
        dateTimePicker = "StartSelection";
    }

    var beginDateTime = moment();

    switch (selectedInterval) {
        case timeIntervalEnum.Day:
            beginDateTime.subtract(1, 'days');
            break;

        case timeIntervalEnum.Week:
            beginDateTime.subtract(1, 'weeks');
            break;

        case timeIntervalEnum.Month:
            beginDateTime.subtract(1, 'months');
            break;

        case timeIntervalEnum.Year:
            beginDateTime.subtract(1, 'years');
            break;

        case timeIntervalEnum.AskedPeriod:
            const from = $("#" + dateTimePicker);
            if (from.length > 0) {
                const picker = from.data("kendoDateTimePicker");
                if (picker && picker.value()) {
                    return picker.value();
                }
                else {
                    const datePicker = from.data("kendoDatePicker");
                    if (datePicker && datePicker.value()) {
                        return datePicker.value();
                    }
                }
            }
            break;
    }

    return new Date(beginDateTime.unix() * 1000);
}

export function getEndPeriodSelection(selectedInterval: number | undefined | null, dateTimePicker: string | undefined | null): Date {

    if (selectedInterval == null || selectedInterval == undefined) {
        selectedInterval = timeIntervalEnum.Day;                            // .LastDay
    }

    if (dateTimePicker == null || dateTimePicker == undefined) {
        dateTimePicker = "EndSelection";
    }

    var endDateTime = moment();

    switch (selectedInterval) {

        case timeIntervalEnum.NextMonth:
            endDateTime.add(1, 'months');
            break;

        case timeIntervalEnum.NextWeek:
            endDateTime.add(7, 'days');
            break;

        case timeIntervalEnum.AskedPeriod:
            const to = $("#" + dateTimePicker);
            if (to.length > 0) {
                const picker = to.data("kendoDateTimePicker");
                if (picker && picker.value()) {
                    return picker.value();
                }
                else {
                    const datePicker = to.data("kendoDatePicker");
                    if (datePicker && datePicker.value()) {
                        return datePicker.value();
                    }
                }
            }
            break;
    }

    return new Date(endDateTime.unix() * 1000);
}
